import { combineReducers } from 'redux'

import supplier from './supplier'
import proposal from './proposal'
import pageReducer from './pageReducer'
import device from './device'
import { createFlagsReducer } from 'flag'
import { reducer as formReducer } from '../components/Common/forms'

const rootReducer = combineReducers({
  supplier,
  proposal,
  page: pageReducer,
  device,
  flags: createFlagsReducer({ features: {} }),
  // To use redux-form, you have to pass formReducer under 'form' key,
  // for custom keys look up the docs for 'getFormState'
  form: formReducer
})

export default rootReducer
